var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProductsInventory1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_252_149)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M405.334 362.667C382.86 362.659 360.786 356.728 341.334 345.472C321.882 356.728 299.808 362.659 277.334 362.667H234.667C212.163 362.638 190.072 356.614 170.667 345.216C151.264 356.616 129.172 362.64 106.667 362.667H85.334C62.8406 362.659 40.7534 356.673 21.334 345.323V448C21.334 464.974 28.0768 481.252 40.0792 493.255C52.0815 505.257 68.3601 512 85.334 512H426.667C443.641 512 459.92 505.257 471.922 493.255C483.925 481.252 490.667 464.974 490.667 448V345.344C471.242 356.679 449.158 362.656 426.667 362.667H405.334Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.667 0V128H320V0H192V128H149.333V0H46.9333L0.512 208.704L0 234.667C0 257.298 8.99045 279.003 24.9936 295.006C40.9967 311.01 62.7015 320 85.3333 320H106.667C118.824 319.961 130.832 317.308 141.874 312.221C152.916 307.134 162.736 299.732 170.667 290.517C178.597 299.732 188.417 307.134 199.459 312.221C210.502 317.308 222.509 319.961 234.667 320H277.333C289.447 320.006 301.422 317.427 312.459 312.435C323.496 307.443 333.34 300.152 341.333 291.051C349.327 300.152 359.171 307.443 370.208 312.435C381.245 317.427 393.22 320.006 405.333 320H426.667C449.298 320 471.003 311.01 487.006 295.006C503.01 279.003 512 257.298 512 234.667V213.333L465.067 0H362.667Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_252_149"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductsInventory1);
export default __webpack_public_path__ + "static/media/Products & Inventory 1.28f7ae95348fc40ebbcc77d3fd08df82.svg";
export { ForwardRef as ReactComponent };